import { TFunction } from "i18next";
import * as Yup from "yup";


export const claimClosedModalSchema = (t: TFunction) => {

    return Yup.object().shape({
        claimDeleteReasonId: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .min(0, t("common:form.requiredFieldForm")),
        closingDate: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .min(0, t("common:form.requiredFieldForm"))
    });
};
